import { Component, Inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatDialogCloseEvent } from '../../../const';
import { DtoTicketCommentDetail } from '../../../models/ticket-details.model';

@Component({
  selector: 'app-view-ticket-comments',
  templateUrl: './view-ticket-comments.component.html'
})
export class ViewTicketCommentsComponent {
  
  comments: DtoTicketCommentDetail[] = [];
  constructor( public dialog: MatDialog, 
    @Optional() public dialogRef: MatDialogRef<ViewTicketCommentsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any ) {}
 

  ngOnInit(): void {
    this.comments = this.data.comments;
  }

  cancel(){
    this.dialogRef.close({event: MatDialogCloseEvent.CANCELLED});
  }
}
